import React, { useEffect } from "react";
import styled from "styled-components";
import HdfcLogo from "../assets/hdfc-life.png";

const CloseScreenContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Full viewport height */
  text-align: center;
  background-color: #f9f9f9; /* Optional background color */
  padding: 20px;
  gap: 10px;
`;

const Heading = styled.h3`
  font-size: 22px;
  font-weight: bold;
  color: #333;
`;

const Message = styled.p`
  font-size: 16px;
  color: #666;
`;
const Logo = styled.img`
  width: 150px;
  position: absolute;
  top: 40%;
`;

const CloseScreen = () => {
  useEffect(() => {
    localStorage.clear();
  }, []);

  return (
    <CloseScreenContainer>
      <Logo src={HdfcLogo} alt="HDFC Life Logo" />
      <Heading>Thanks for taking the PIVV process.</Heading>
      <Message>You may close this window.</Message>
    </CloseScreenContainer>
  );
};

export default CloseScreen;
